export default function ReportSectionTitle({ title, hideMarginTop }) {
  return (
    <div className={`${!hideMarginTop ? "mt-2 " : ""}report_title_section`}>
      <label style={{ fontSize: "14px", whiteSpace: "nowrap" }}>{title}</label>
    </div>
  );
}
